import { fetchAPI } from "./apiCore";


// Fetch consent management statistics
export const fetchConsentStats = async () => {
  try {
    return await fetchAPI("admin/consent/stats", "GET");
  } catch (error) {
    console.error("Error fetching consent stats:", error);
    return {
      reviewsNeeded: 0,
      expiredConsents: 0,
      activeConsents: 0,
    };
  }
};


// Parse a signed consent PDF without saving the file on the backend.
export const parseConsentPdfMetadata = async (
  file
) => {
  if (!file) {
    throw new Error("A PDF file is required");
  }

  const formData = new FormData();
  formData.append("file", file);

  return fetchAPI(
    "biobank/consent/pdf-metadata/parse",
    "POST",
    {},
    formData
  );
};


// Patch selected fields on an existing consent record.
export const patchConsent = async (consentId, patchData) => {
  if (!consentId) {
    throw new Error("A consent ID is required");
  }
  if (!patchData || typeof patchData !== "object") {
    throw new Error("Consent patch data is required");
  }

  return fetchAPI(`biobank/consent/${consentId}`, "PATCH", {}, patchData);
};


// CONSENT MANAGEMENT API FUNCTIONS
export const fetchConsentExtendedList = async (params = {}) => {
  // The backend page-size parameter is `size`. This used to send `limit`, which
  // Spring silently dropped, so every page fell back to 10 rows while the grid
  // paged in steps of 25/50 and skipped records.
  const { page = 0, size = 25, consentType, sortBy, sortDirection } = params;

  try {
    const queryParams = { page, size };
    if (consentType) {
      queryParams.consentType = consentType;
    }
    if (sortBy) {
      queryParams.sortBy = sortBy;
    }
    if (sortDirection) {
      queryParams.sortDirection = sortDirection;
    }
    return await fetchAPI('biobank/consent/extended-list', 'GET', queryParams);
  } catch (error) {
    console.error('Error fetching consent extended list:', error);
    throw error;
  }
};


// NEW CONSENT FLOW API FUNCTIONS (G3 Refactor)

// Get consent form selection (grouped by general, scheduled study, other study)
export const getConsentFormSelection = async (patientId, encounterId, language) => {
  return await fetchAPI(
    `biobank/consent/forms/selection?patientId=${patientId}&encounterId=${encounterId || ''}&language=${language || ''}`,
    "GET"
  );
};

// Submit consents after Adobe Sign completion
export const submitConsents = async (patientId, consents) => {
  return await fetchAPI(
    "biobank/consent/submit",
    "POST",
    {},
    { patientId, consents }
  );
};

// Get eligibility preview to verify effective active consents
export const getEligibilityPreview = async (patientId, encounterId) => {
  return await fetchAPI(
    `biobank/consent/eligibility/preview?patientId=${patientId}&encounterId=${encounterId || ''}`,
    "GET"
  );
};
